// Visible keyboard focus for the reporting surfaces.
//
// Every action in this area measured `outline: none` with no box-shadow, so a
// keyboard user could reach each control and see nothing. :focus-visible is
// used rather than :focus so a mouse click does not leave a ring behind.
//
// Scoped to reporting on purpose. The same gap exists app-wide in the theme,
// and fixing it there is a separate change with its own blast radius; this
// does not widen into it.
export const reportingFocusVisibleSx = {
    '& :focus-visible': {
        outline: '2px solid #6366f1',
        outlineOffset: '2px',
        borderRadius: '6px',
    },
};

export default reportingFocusVisibleSx;
